import React, { useId, useState } from "react";
import { Button, Collapse, useMediaQuery } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { useLang } from "../i18n";
import { useTransportV2 } from "../context/TransportV2Context";
import { plantChangeTargets, selectedPlantChanges } from "../utils/plantChanges";

// DEV181: reine Information ohne Pflichtkästchen; disabled bleibt für die Aufrufer erhalten.
export default function PlantChangeConfirmation({ disabled: _disabled = false }) {
  const { state } = useTransportV2();
  const { t } = useLang();
  const id = useId();
  const [expanded, setExpanded] = useState(false);
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const changes = selectedPlantChanges(state);
  const renderChange = change => <li key={change.key}>
      <strong>{t("plantChange.replacement", { from: change.from, to: change.to })}</strong>
      <span className="tiny muted">{change.targetInstance} · {change.designType || t(`plantChange.${change.kind}`)} · {t(`plantChange.${change.field}`)}</span>
      <span>{t("plantChange.source")}: {change.source}</span>
      <span>{t("plantChange.target")}: {change.target}</span>
    </li>;
  if (!changes.length) return null;
  return <section className="plant-change-warning sect" aria-labelledby={`${id}-title`}>
    <h3 id={`${id}-title`}>{(() => { const ziele = plantChangeTargets(changes); return ziele.length === 1 ? t("plantChange.title", { to: ziele[0] }) : t("plantChange.titleMany"); })()}</h3>
    <p>{(() => { const ziele = plantChangeTargets(changes), quellen = [...new Set(changes.map(change => change.from).filter(Boolean))];
      return ziele.length === 1 && quellen.length === 1 ? t("plantChange.description", { from: quellen[0], to: ziele[0] }) : t("plantChange.descriptionMany"); })()}</p>
    <ul>{changes.slice(0, 2).map(renderChange)}</ul>
    {changes.length > 2 && <>
      <Button aria-expanded={expanded} aria-controls={`${id}-remaining`}
        startIcon={expanded ? <ExpandLess /> : <ExpandMore />}
        onClick={() => setExpanded(value => !value)}>
        {expanded ? t("plantChange.showLess") : t("plantChange.showMore", { n: changes.length - 2 })}
      </Button>
      <Collapse id={`${id}-remaining`} in={expanded} timeout={reducedMotion ? 0 : "auto"} unmountOnExit>
        <ul>{changes.slice(2).map(renderChange)}</ul>
      </Collapse>
    </>}
    <p className="tiny muted">{t("plantChange.preserve")}</p>
  </section>;
}
